<div mat-dialog-content>
    <modal-pqrPageClientInitNew (closeDialog)="onClose()" [formId]="formId"></modal-pqrPageClientInitNew>
</div>